import { useState,createContext, useEffect, useContext } from "react";
import { useCookies } from 'react-cookie';
import { SnackbarProvider } from 'notistack';


export const UserDataContext = createContext()
export const ContextFromSelections  = createContext(null)
export const FetchedDataContext = createContext([]);
export const AllowRouteVerification = createContext(null)
export const Notification = createContext(null)
export const ReadyToCheckout = createContext(null)
export const ShoppingCartContext = createContext(null)
export const CreateRoute = createContext({
        path: "",
        element: " ",
        params: " "
    })




export function ReadyToCheckoutProvider({children}) {
    const [isReady, setIsReady] = useState(false)
    
    return(
        <ReadyToCheckout.Provider value={[isReady, setIsReady]}>
            {children}
        </ReadyToCheckout.Provider>
    )
}





export function ContextFromSelectionsProvider({children}) {

    const dataFromStorage = JSON.parse(localStorage?.getItem("selectionStorage"))
    const [selectedData, setSelectedData] = useState(dataFromStorage  || {
        ribbonColorCode: null,
        ribbonColor: null,
        ribbonLenght: null,
        ribbonWidth: null,
        fontColor: null,
        fontColorCode: null,
        textOnRibbon: null,
        ribbonBorderAdd: false,
        addText: false,
        font: null,
        icon: null,
        extra_options_byuser: ""
    });
    
    
   
    useEffect(() => {
        localStorage.setItem("selectionStorage",JSON.stringify(selectedData))
    },[selectedData])

    return(
        <ContextFromSelections.Provider value={[selectedData, setSelectedData]}>
            {children}
        </ContextFromSelections.Provider>
    );
};



export function FetchedDataContextProvider ({children}) {

    const [FetchedData, setFetchedData] = useState(new Map())
    const [userData] = useContext(UserDataContext)
    const {userIsLogin} = userData

    

    const ApiUrls = {
    
        "fetchedRibbonColors": `${process.env.REACT_APP_API_URL}/get_colors`,
        "fetchedFontColors": `${process.env.REACT_APP_API_URL}/get_font_colors`,
        "fetchedFontNames":  `${process.env.REACT_APP_API_URL}/get_font_names`,
        "fetchDisplayInfo": `${process.env.REACT_APP_API_URL}/displayinfofront`,
        "fetchShopCart": `${process.env.REACT_APP_API_URL}/shopcart`,
    };

    useEffect(() => {
        
            const  fetchdata = async () => {
            try {
                const promiseData =  await Promise.all(Object.values(ApiUrls).map((url) => fetch(url,{"credentials": "include"}).then((res) => res.json())))
                const MapingObj = new Map()
                Object.keys(ApiUrls).map((urlname,index) => (MapingObj.set(urlname,promiseData[index])))
                setFetchedData(MapingObj)
                
                }
            catch (error) {
                    console.log(error)
            }
        }

        fetchdata();
        
    },[userIsLogin])
  
    return(
        <FetchedDataContext.Provider value={FetchedData}>
            {children}
        </FetchedDataContext.Provider>
    
    )

};




export function UserDataContextProvider({children}) {

    const [cookies] = useCookies(["_acc_t","_fixed_time","_in_user"])
    const [userData,setUserData] = useState([])
   


    useEffect(() => {
        setUserData((data) => ({
            ...data,
            username: cookies._in_user,
            userToken: cookies._acc_t,
            userIsLogin: cookies._acc_t ? true: false,
            tokenFixedTime: cookies._fixed_time
        }))
    },[cookies._acc_t,cookies._fixed_time,cookies._in_user])


 
   return(
        <UserDataContext.Provider value={[userData,setUserData]}>
            {children}
        </UserDataContext.Provider>
    );

}




export function NotificationsProvider({children}) {
    
    

    return(
        
        <SnackbarProvider maxSnack={1}>
                {children}
        </SnackbarProvider>
    )

}

export function CreateRouteProvider({children}) {

    const [params, setParams] = useState({
        path: "",
        element: "",
        params: ""
    })

    return(
        <CreateRoute.Provider value={[params, setParams]}>
            {children}
        </CreateRoute.Provider>
    )

}

                
                
export function ShoppingCartContextProvider({children}) {

    const FetchedData = useContext(FetchedDataContext)
    const [shopCart,setShopCart] = useState([])




    useEffect(() => {
        setShopCart(FetchedData.get("fetchShopCart"))
        },[FetchedData])
    
    
    
    
    return(
        <ShoppingCartContext.Provider value={[shopCart,setShopCart]}>
            {children}
        </ShoppingCartContext.Provider>
    )
}




        
       
    
        
       
    
   